<div fxLayout="column" fxLayoutGap="16px">
  <p>{{'my_service.description' | translate }}</p>

  <mat-slide-toggle [(ngModel)]="twoHigh0" (ngModelChange)="updatePAProfileInBackend()" class="settingsButton">
    {{'my_service.connect_anyway' | translate}}
  </mat-slide-toggle>

  <mat-slide-toggle [(ngModel)]="twoHigh1" (ngModelChange)="updatePAProfileInBackend()" class="settingsButton">
    {{'my_service.connect_colleague' | translate}}
  </mat-slide-toggle>

  <mat-form-field class="numberSelection" *ngIf="twoHigh1">
    <mat-select [(ngModel)]="colleagueNumber" (selectionChange)="changeColleagueNumber($event)">
      <mat-option *ngFor="let contact of colleagueNumbers" [value]="contact.phoneNumber">{{contact.name}}
        {{contact.getFormattedNumber()}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-slide-toggle [(ngModel)]="twoHigh2" (ngModelChange)="updatePAProfileInBackend()" class="settingsButton">
    {{'my_service.connect_main_number' | translate}}
  </mat-slide-toggle>

  <mat-form-field class="numberSelection" *ngIf="twoHigh2">
    <mat-select class="numberSelection" [(ngModel)]="mainNumber" (selectionChange)="changeMainNumber($event)">
      <mat-option *ngFor="let number of serviceNumbers" [value]="number.phoneNumber">{{number.name}}
        {{number.getFormattedNumber()}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <button mat-raised-button (click)="onBack()" color="primary">
    {{'global.back' | translate}}
  </button>
</div>